var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-menu-item',{attrs:{"w":"294px","h":"100px","p":"8px","border":"1px solid #008C81","rounded":"md","_hover":{
    bg: 'transparent',
  },"_focus":{
    outline: 'none',
    bg: 'none',
    boxShadow: 'none',
  }},on:{"click":function($event){return _vm.$emit('click')}}},[_c('c-image',{attrs:{"src":_vm.icon}}),_c('c-text',{attrs:{"font-style":"normal","font-weight":"500","font-size":"18px","line-height":"150%","color":"#111111"}},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }